import React from "react";
import { Link } from "react-router-dom";
import "./sideBar.css";
import navList from "../../data/navList";
import NavItems from "../navigation/NavItems";

const SideBar = () => {
  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        <li className="nav-item">
          {/* <a className="nav-link" href="#"> */}
          <Link className="nav-link" to="/dashboard">
            <i className="bi bi-grid"></i>
            <span>Dashboard</span>
          </Link>
          {/* </a> */}
        </li>

        <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-bs-target="#components-nav"
            data-bs-toggle="collapse"
            href="#"
          >
            <i className="bi bi-journal-plus"></i>
            <span>Masters</span>
            <i className="bi bi-chevron-down ms-auto"></i>
          </a>
          <ul
            id="components-nav"
            className="nav-content collapse"
            data-bs-parent="#sidebar-nav"
          >
            {/* <li>
              <Link to="/marfish/category">
                <i className="bi bi-circle"></i>
                <span>Category</span>
              </Link>
            </li> */}
            <li>
              <Link to="/customer">
                <i className="bi bi-circle"></i>
                <span>Customer</span>
              </Link>
            </li>
            {/* <li>
              <Link to="/marfish/customertype">
                <i className="bi bi-circle"></i>
                <span>Customer Type</span>
              </Link>
            </li> */}
            <li>
              <Link to="/gender">
                <i className="bi bi-circle"></i>
                <span>Gender</span>
              </Link>
            </li>
            <li>
              <Link to="/item">
                <i className="bi bi-circle"></i>
                <span>Item</span>
              </Link>
            </li>
            <li>
              <Link to="/uom">
                <i className="bi bi-circle"></i>
                <span>UoM</span>
              </Link>
            </li>
          </ul>
        </li>

        <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-bs-target="#forms-nav"
            data-bs-toggle="collapse"
            href="#"
          >
            <i className="bi bi-cash"></i>
            <span>Transactions</span>
            <i className="bi bi-chevron-down ms-auto"></i>
          </a>
          <ul
            id="forms-nav"
            className="nav-content collapse"
            data-bs-parent="#sidebar-nav"
          >
            <li>
              <Link to="/sales">
                <i className="bi bi-circle"></i>
                <span>Sales</span>
              </Link>
            </li>
          </ul>
        </li>

        <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-bs-target="#tables-nav"
            data-bs-toggle="collapse"
            href="#"
          >
            <i className="bi bi-file-earmark-text"></i>
            <span>Reports</span>
            <i className="bi bi-chevron-down ms-auto"></i>
          </a>
          <ul
            id="tables-nav"
            className="nav-content collapse"
            data-bs-parent="#sidebar-nav"
          >
            <li>
              <Link to="/collectionreport">
                <i className="bi bi-circle"></i>
                <span>Collections</span>
              </Link>
            </li>
            <li>
              <Link to="/salesreport">
                <i className="bi bi-circle"></i>
                <span>Sales</span>
              </Link>
            </li>
            <li>
              <Link to="/summaryreport">
                <i className="bi bi-circle"></i>
                <span>Summary</span>
              </Link>
            </li>
          </ul>
        </li>

        {/* <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-bs-target="#charts-nav"
            data-bs-toggle="collapse"
            href="#"
          >
            <i className="bi bi-bar-chart"></i>
            <span>Charts</span>
            <i className="bi bi-chevron-down ms-auto"></i>
          </a>
          <ul
            id="charts-nav"
            className="nav-content collapse"
            data-bs-parent="#sidebar-nav"
          >
            <li>
              <a>
                <i className="bi bi-circle"></i>
                <span>Chart.js</span>
              </a>
            </li>
            <li>
              <a>
                <i className="bi bi-circle"></i>
                <span>ApexCharts</span>
              </a>
            </li>
            <li>
              <a>
                <i className="bi bi-circle"></i>
                <span>ECharts</span>
              </a>
            </li>
          </ul>
        </li> */}

        {/* <li className="nav-item">
          <a
            className="nav-link collapsed"
            data-bs-target="#icons-nav"
            data-bs-toggle="collapse"
            href="#"
          >
            <i className="bi bi-gem"></i>
            <span>Icons</span>
            <i className="bi bi-chevron-down ms-auto"></i>
          </a>
          <ul
            id="icons-nav"
            className="nav-content collapse"
            data-bs-parent="#sidebar-nav"
          >
            <li>
              <a>
                <i className="bi bi-circle"></i>
                <span>Chart.js</span>
              </a>
            </li>
            <li>
              <a>
                <i className="bi bi-circle"></i>
                <span>Bootstrap Icons</span>
              </a>
            </li>
            <li>
              <a>
                <i className="bi bi-circle"></i>
                <span>Remix Icons</span>
              </a>
            </li>
            <li>
              <a>
                <i className="bi bi-circle"></i>
                <span>Boxicons</span>
              </a>
            </li>
          </ul>
        </li> */}

        <li className="nav-heading">Pages</li>
        {navList.map((nav) => (
          <NavItems key={nav.id} nav={nav} />
        ))}
      </ul>
    </aside>
  );
};

export default SideBar;
